export default __webpack_public_path__ + "static/media/news-06.3b78eca0.jpg";